import {
  expected,
  isDefined,
  schAlertType,
  schPairedCostRouteItemWithQuery,
} from '@aloft/toolkit-shared';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../../redux/types.ts';
import {
  LocationType,
  formatMiles,
  getLocationTypeProximityRequirementMiles,
} from '../../../../utils/locationTypeProximityRequirementMiles.ts';
import { proximityMiles } from '../../../../utils/proximityMiles.ts';
import { AlertDefinition } from '../../types.ts';

export const outsideProximityRequirement: AlertDefinition = ({
  compSequence,
  propertyDataEntities,
}) => {
  const subject = propertyDataEntities.subject as SubjectPropertyDataState | undefined;
  const locationType = subject?.subjectData.editableData.propertyIdentification.locationType as
    | LocationType
    | undefined;
  const proximityRequirementMiles = getLocationTypeProximityRequirementMiles(locationType);
  const subjectCoords = subject?.subjectData.editableData.propertyIdentification.coordinates;

  if (!locationType || proximityRequirementMiles === undefined || !subjectCoords) return undefined;

  const outOfRangeCount = compSequence
    .map((id) => propertyDataEntities[id] as CompPropertyDataState | undefined)
    .map((comp) => comp?.compData.editableData.propertyIdentification.coordinates)
    .filter(isDefined)
    .map((coords) => proximityMiles(subjectCoords, coords))
    .filter((miles) => miles !== undefined && miles > proximityRequirementMiles).length;

  if (outOfRangeCount === 0) return undefined;

  const countText =
    outOfRangeCount === 1 ? 'One comparable is' : `${outOfRangeCount} comparables are`;

  return {
    type: schAlertType.enum.outsideProximityRequirement,
    status: 'active',
    message: `${countText} outside the suggested ${formatMiles(proximityRequirementMiles)} proximity for ${locationType} locations.`,
    propertyID: 'subject',
    fixingInfo: {
      tips: `Tips: Use the Recommended Comps tool to replace out-of-range comps, or provide commentary if using a more distant comp is necessary for the assignment.`,
      pairedCostRouteItem: expected(
        schPairedCostRouteItemWithQuery.parse('features?addComps=true'),
      ),
    },
  };
};
